import { useContext, useState } from "react";

import { AncillaryContentSubtype } from "../../../common/types/AncillaryContentType";
import { GetAncillaryListRequest } from "../api/GetAncillaryListRequest";
import { useAssetsManageAncillaryApi } from "../api/useAssetsManageAncillaryApi";
import { ManageAncillaryContext } from "../context/ManageAncillaryContext";
import { mapToAncillaryItem } from "./AncillaryItem";
import { AncillaryListingFilters } from "./useAncillaryListingFilters";

export const useAncillaryListing = () => {
    const { getAncillaryList } = useAssetsManageAncillaryApi();

    const [totalItems, setTotalItems] = useState<number>(0);
    const [isListLoading, setIsListLoading] = useState<boolean>(true);

    const setItems = useContext(ManageAncillaryContext).setAncillaryItems;
    const ancillaryContentType = useContext(ManageAncillaryContext).ancillaryContentType;

    const getData = async (filters: AncillaryListingFilters): Promise<void> => {
        setIsListLoading(true);
        const request: GetAncillaryListRequest = createGetAncillaryListRequest(filters, ancillaryContentType);

        const response = await getAncillaryList(request);
        const ancillaryManagerItems = response.items.map(mapToAncillaryItem);

        setItems(ancillaryManagerItems);
        setTotalItems(response.totalCount);
        setIsListLoading(false);
    };

    return {
        totalItems,
        isListLoading,
        getData
    };
};

const createGetAncillaryListRequest = (
    filters: AncillaryListingFilters,
    contentType: AncillaryContentSubtype
): GetAncillaryListRequest => {
    return {
        page: filters.page,
        pageSize: filters.pageSize,
        sortBy: filters.sortBy,
        sortOrder: filters.sortOrder,
        title: filters.title,
        includeMerged: filters.includeMerged,
        brandingIds: filters.brandings,
        versionTypeIds: filters.versionTypes,
        sources: filters.sources,
        subtype: contentType
    };
};
